const GIFT_RECEIPT_LABELS = {
  global: {
    giftReceipt: {
      lbl_print_gift_receipt_heading: 'RETURN GIFT RECEIPT',
      lbl_print_gift_receipt_return_by: 'Return By',
    },
  },
};

export default GIFT_RECEIPT_LABELS;
